// Session AAY: the office-facing caution shown BEFORE confirming a project-reference rename.
// Mirrors the server's projectRenameWarning (server/src/modules/projects/projects.ts) so the
// two-step confirm can name the history before the request goes; the server recomputes the same
// warning authoritatively and returns it on the response. Kept in lock-step by projectRename.test.ts.
//
// Renaming is always ALLOWED (it is the Director's call). This returns the one-line caution when
// the project already carries history tied to the OLD reference (a signed quotation, or one or more
// invoices), or null when there is nothing worth warning about (a plain inline save).
export function projectRenameWarning(input: {
  oldRef: string;
  hasSignedQuotation: boolean;
  invoiceCount: number;
}): string | null {
  const parts: string[] = [];
  if (input.hasSignedQuotation) parts.push("a signed quotation");
  if (input.invoiceCount > 0) parts.push(`${input.invoiceCount} invoice${input.invoiceCount === 1 ? "" : "s"}`);
  if (parts.length === 0) return null;
  const list = parts.length === 1 ? parts[0] : `${parts[0]} and ${parts[1]}`;
  return `This project has ${list} referencing ${input.oldRef}. Existing documents keep the old reference; only new activity will use the new one.`;
}
